import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'mess_validemail_dialog',
    templateUrl: 'mess_validemail_dialog.component.html',
    styleUrls: ['mess_validemail_dialog.component.scss']
})
export class MessValidemail implements OnInit {
    objectKeys = Object.keys;
    
    constructor(
        private router: Router,
        public dialogRef: MatDialogRef<MessValidemail>,
        @Inject(MAT_DIALOG_DATA) public data: any //email + message
    ) {}

    ngOnInit() {
    }

    dismissDialog(){
        this.router.navigateByUrl("/homepage");
        this.dialogRef.close({});
    }

}